import { render, staticRenderFns } from "./UsersOpinion.vue?vue&type=template&id=7617011d&scoped=true&"
import script from "./UsersOpinion.vue?vue&type=script&lang=js&"
export * from "./UsersOpinion.vue?vue&type=script&lang=js&"
import style0 from "./UsersOpinion.vue?vue&type=style&index=0&id=7617011d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7617011d",
  null
  
)

export default component.exports